import React from "react";
import s from "./ChatHeaderUI.pcss";

export function ChatHeaderUI({children, leftAddon, rightAddon}) {
    return (
        <div className={s.header}>
            <div className={s.leftAddon}>{leftAddon}</div>
            <div className={s.chatTitle}>{children}</div>
            <div className={s.rightAddon}>{rightAddon}</div>
        </div>
    );
}

function ChatHeaderUITitle({children}) {
    return <div className={s.title}>{children}</div>;
}

ChatHeaderUI.Title = ChatHeaderUITitle;
